import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AppShell from './components/layout/AppShell';
import ToastContainer from './components/ui/ToastContainer';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import PlaceholderPage from './pages/PlaceholderPage';
import AllProducts from './pages/products/AllProducts';
import ManageProduct from './pages/products/ManageProduct';
import ManageCertificates from './pages/certificates/ManageCertificates';
import { ThemeProvider } from './context/Themecontext';
import AllCertifications from './pages/certificates/AllCertifications';
import AllFiles from './pages/contents/AllFiles';
import UploadNew from './pages/contents/UploadNew';
import AllInvoices from './pages/invoices/AllInvoices';
import QuoteRequests from './pages/quotes/AllQuotes';
import AdminControls from './pages/settings/AdminControls';
import Analytics from './pages/analytics';
import AllBlogs from './pages/blogs/AllBlogs';
import ManageBlog from './pages/blogs/ManageBlog';

export default function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <ThemeProvider>
          <BrowserRouter>
            <Routes>
              {/* Public */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />

              {/* Protected */}
              <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/content/analytics" element={<Analytics />} />
                <Route path="/content/products" element={<AllProducts />} />
                <Route path="/manage/product" element={<ManageProduct />} />
                <Route path="/content/certifications" element={<AllCertifications />} />
                <Route path="/manage/certification" element={<ManageCertificates />} />
                <Route path="/quotes" element={<QuoteRequests />} />
                <Route path="/invoices" element={<AllInvoices />} />
                <Route path="/content/blogs" element={<AllBlogs />} />
                <Route path="/manage/blog" element={<ManageBlog />} />
                <Route path="/content/files" element={<AllFiles />} />
                <Route path="/content/upload" element={<UploadNew />} />
                <Route path="/settings" element={<AdminControls />} />
                <Route path="/content/home" element={<PlaceholderPage />} />
                <Route path="/content/contact" element={<PlaceholderPage />} />
                <Route path="/content/about" element={<PlaceholderPage />} />
                <Route path="/pages" element={<PlaceholderPage />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Route>
            </Routes>
            <ToastContainer />
          </BrowserRouter>
        </ThemeProvider>
      </ToastProvider>
    </AuthProvider>
  );
}
